import { render } from "./App.vue?vue&type=template&id=f0272e68"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Accent\\Vue_Projects\\NEWWEBECOM_OCT6_2026\\Accent-MIO\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__